import React, { useRef, useState, useMemo, useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService.jsx";
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent.jsx';
import Spinner2 from "../../common/Spinner/Spinner2.jsx";
import commonApiService from '../../../../shared/common-utilities/services/commonApiService.jsx';
import { fetchSavedView, planGroups, planGroupResources } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts.jsx';
import { Grid } from '@mui/material';
import AlertComponent from '../../../../shared/common-utilities/common/AlertComponent.jsx';
import { CommonConst as Consts } from '../../../../shared/common-utilities/enums/CommonConst.jsx';

let entity = "trailer";
let odataApiName = "trailers";
let odataApiNameFor = "trailers";
let service = getSetDataService();
let apiService = commonApiService();
const dataRelatedAction = ['Filter', 'View Columns', 'Settings', 'Refresh', 'New Window'];
let gridSelectedValues = {};

//#region SortData start

const Resources = (props) => {
	//#region Reference
	const subContractorGrid = useRef(null);
	//#endregion Reference

	const transportAddressDataItemKey = "id";
	const initialSort = service.initialSort[entity];
	const userID = localStorage.getItem('userID');
	const startDate = new Date();
	const days = 300;


	//#region States - Get set variables
	const [resourceData, setTempResourceData] = useState([]);
	const [resourceGridColumnList, setResourceGridColumnList] = useState(null);
	const [tempResourceGridColumnList, setTempResourceGridColumnList] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [isResource, setIsResource] = useState(true);
	const [loadedGridData, setLoadedGridData] = useState(resourceData);
	const [myGridData, setmyGridData] = useState([]);
	const [loadSelectionValue, setloadSelectionValue] = useState(100);
	const [totalData, setTotalData] = useState();
	const [isApiLoaded, setIsApiLoaded] = useState(false);
	const [paramsData, setParamsData] = useState(null);
	let [initialFilter, setInitialFilter] = useState([]);
	const [nextDataUrl, setNextDataUrl] = useState(null);
	const [initialSaveViewData, setInitialSaveViewData] = useState([]);
	const [initialFetchReadLinkData, setInitialFetchReadLinkData] = useState(null);
	const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
	const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
	const [changeToChildResource, setChangeToChildResource] = useState(null);
	const [isApiCallRequired, setIsApiCallRequired] = useState(true);
	const [myResources, setMyResources] = useState([])
	const [resourceTypeData, setResourceTypeData] = useState([])
	const [selectedGrpData, setSelectedGrpData] = useState({ code: Consts.CHASSIS })
	const [selectedRecData, setSelectedRecData] = useState({})

	const resDefaultFilters = [
		// { type: 'DatePicker', key: 'startDate', value: startDate, label: 'Start Date', placeholder: 'Start date...' },
		// { type: 'NumericTextBox', key: 'daysToShow', value: days, label: 'Days To Show', placeholder: 'Please enter value', relationalField: 'startDate' },
		{ type: 'DropDownList', key: 'resourceType', value: null, label: 'Resource Type', data: [] },
		{ type: 'DropDownList', key: 'planGroup', value: null, label: 'Plan Group', data: [] },
	];
	const [resFilterComponents, setResFilterComponents] = useState(resDefaultFilters);

	const setGridColumns = (entityName) => {
		const columnList = localStorage.getItem(entityName + 'ColumnList');
		if (!_.isNil(columnList)) {
			setResourceGridColumnList(JSON.parse(columnList));
			getColList(JSON.parse(columnList));
			return true;
		}

		apiService.getODataMetadata().then(odataRes => {
			service.entityDefinitions(odataRes, entityName).then((tempFieldList) => {
				localStorage.setItem(entityName + 'ColumnList', JSON.stringify(tempFieldList));
				setResourceGridColumnList(tempFieldList);
				getColList(tempFieldList);
			})
		}).catch(error => {
			console.error('API error:', error);
		})
	}
	const getDefaultColList = (dcolsStringSC, gridcolumns) => {
		const dCols = JSON.parse(localStorage.getItem("defaultColumnSetting"));
		if (!_.isNil(dcolsStringSC) && dcolsStringSC != "undefined") {
			const defaultColumnListSC = gridcolumns?.filter(item => {
				return dCols[entity]?.split("~").includes(item.field);
			});
			if (defaultColumnListSC.length == 0) {
				localStorage.setItem(entity + 'TempColumnList', JSON.stringify(gridcolumns));
				setTempResourceGridColumnList(gridcolumns);
			} else {
				const sortedArr = _.sortBy(defaultColumnListSC, function (item) { return dCols[entity]?.split("~").indexOf(item.field) });
				localStorage.setItem(entity + 'TempColumnList', JSON.stringify(sortedArr));
				setTempResourceGridColumnList(sortedArr);

				const arr1 = sortedArr;
				const arr2 = gridcolumns.filter(e => !sortedArr.map(x => x.field).includes(e.field));
				const newsortedArr = _.concat(arr1, arr2);
				setResourceGridColumnList(newsortedArr);
			}
		} else {
			localStorage.setItem(entity + 'TempColumnList', JSON.stringify(gridcolumns));
			setTempResourceGridColumnList(gridcolumns);
		}
	}
	const getColList = (gridcolumns) => {
		const scUrl = `${fetchSavedView}?$filter=(title eq '${odataApiNameFor}' and userID eq '${userID}')`;
		const dcolsStringSC = localStorage.getItem("defaultColumnSetting");
		apiService.get(scUrl).then(savedViewRes => {
			if (savedViewRes?.value?.length > 0) {
				apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], null, null, null, null, savedViewRes.value[0]["@odata.etag"]).then(readResSC => {
					if (readResSC !== undefined && readResSC !== null) {
						setInitialSaveViewData(savedViewRes.value);
						setInitialFetchReadLinkData(readResSC);
						const defaultViewExist = readResSC[odataApiNameFor]?.savedViews?.filter(item => item.defaultView);
						if (defaultViewExist?.length > 0 && defaultViewExist?.[0]?.subviews?.length > 0) {
							const favFilterExist = defaultViewExist[0]?.subviews?.filter(subView => subView.isDefaultFilter);
							if (favFilterExist?.length > 0) {
								setTempResourceGridColumnList(defaultViewExist[0].columns);
							}
						} 
						// else if (readResSC[odataApiNameFor]?.columns?.length !== 0) {
						// 	localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(readResSC[odataApiNameFor]?.columns));
						// 	setTempResourceGridColumnList(readResSC[odataApiNameFor]?.columns);
						// } 
						else {
							getDefaultColList(dcolsStringSC, gridcolumns);
						}
					}
				})
			} else {
				getDefaultColList(dcolsStringSC, gridcolumns);
			}

			setIsLoading(false);
		});
	}
	const changePlanGroup = (value) => {
		const resourceTypeMatch = value?.filter?.match(/resourceType eq '([^']+)'/);
		const planGroupMatch = value?.filter?.match(/planGroup eq '([^']+)'/);
		if (resourceTypeMatch) {
			const resourceTypeValue = resourceTypeMatch[1];
			const planGrpTypeVal = planGroupMatch && planGroupMatch[1];
			let planGrp = myResources.filter((item) => item?.resourceType == resourceTypeValue)
			let plamGrpVal = myResources.filter((item) => item.code == planGrpTypeVal)
			setSelectedGrpData(planGrp[0])
			let typeName = resourceTypeValue
			if (resourceTypeValue == 'CHASSIS')
				typeName = 'trailers'
			else if (resourceTypeValue == 'VARIOUS')
				typeName = 'variousResources'
			entity = resourceTypeValue == 'VARIOUS' ? typeName.substring(0, typeName.length - 1) : typeName.toLowerCase().substring(0, typeName.length - 1);
			odataApiName = typeName.toLowerCase();
			odataApiNameFor = typeName.toLowerCase();

			if (planGrp.length > 0)
				planGrp.unshift({ code: "All" });

			setResourceGridColumnList([])
			setTimeout(() => {
				setGridColumns(entity)
			}, 100);

			setResFilterComponents(prevComponents =>
				prevComponents.map(component =>
					component.key === 'planGroup'
						? { ...component, data: planGrp, value: planGrpTypeVal ? plamGrpVal[0] : planGrp[0] }
						: component
				)
			);
		} else {
			console.log('resourceType not found');
		}
	}
	const childStateHandler = (value, flag) => {
		if (flag === 'showGridHeader') {
			setIsResource(value);
		} else if (flag === 'getData') {
			setNextDataUrl(null);
			changePlanGroup(value)
			setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
			setIsApiCallRequired(value.isApiCall);
			setTempResourceGridColumnList(value.columns);
		} else if (flag === 'refresh') {
			sendApi(null, loadSelectionValue);
		} else if (flag === 'selectedValues') {
			gridSelectedValues = value;
		} else if (flag === 'columnsVisible') {
			setTempResourceGridColumnList(value);
		}
	}
	const handleErrorSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setErrorSnackbarOpen(false);
	};
	const onLoadSelectionChange = (e) => {
		let value = e.value;
		setloadSelectionValue(value);
		sendApi(null, value);
	}
	const setErrorParameterAndMessage = (errMsg) => {
		setCommonPopupParameters({
			title: 'Error'
		});
		setErrorMessage(errMsg);
		setopenConfirmationModal(true);
	}

	// --- API's Call START ---
	const sendApi = (val, size) => {
		let filter = paramsData?.filter ? '$filter=(' + paramsData?.filter + ')' : null;
		// let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
		if (tempResourceGridColumnList !== null && tempResourceGridColumnList !== undefined && tempResourceGridColumnList?.length > 0) {
			setIsLoading(true);

			if (selectedGrpData?.code == Consts.VEHICLES) {
				filter += "&$expand=vehicles($expand=resourceQualifications)"
			} else if (selectedGrpData?.code == Consts.TRAILERS || selectedGrpData?.code == Consts.CHASSIS) {
				filter += "&$expand=trailers($expand=resourceQualifications)"
			} else if (selectedGrpData?.code == Consts.DRIVERS) {
				filter += "&$expand=drivers($expand=resourceQualifications)"
			} else if (selectedGrpData?.code == Consts.VARIOUS) {
				filter += "&$expand=variousResources($expand=resourceQualifications($select=description,typeQualification))"
			}

			// '&' + orderby 
			const params = '&' + filter + '&$count=true';
			const columns = tempResourceGridColumnList?.map(item => item.field);
			const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName);
			if (!_.isNull(mandatroyEntity)) {
				let splitedColums = mandatroyEntity?.mandatoryColumns.split("~");
				splitedColums?.forEach(element => {
					if (!columns.includes(element)) {
						columns.push(element)
					}
				});
			}

			const selectFields = `&$select=${columns}`;
			const oDataNextLink = val == 'Scroll' ? nextDataUrl : null;
			// `${selectFields}`
			apiService.get(planGroupResources, params, null, oDataNextLink, size, null).then(response => {
				if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
					setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
					if (response?.error?.message?.includes('$orderby')) {
						const sortToRemoveSC = response.error.message.split("'")[1];
						setChangeToChildResource({ type: "sort", value: sortToRemoveSC });
					} else if (response?.error?.code == "Application_FilterErrorException") {
						const filterToRemoveSC = response.error.message.split("'")[1];
						setChangeToChildResource({ type: "filter", value: filterToRemoveSC });
					}
				} else {
					if (response.value) {
						let tempData = [];
						if (val == 'Scroll' && resourceData !== null && resourceData !== undefined && resourceData.length > 0) {
							resourceData.forEach(tempContractor => {
								tempData.push(tempContractor);
							});
							response.value.map(temp => {
								tempData.push(temp)
							})
						}
						// Update the data based on the response
						else {
							tempData = response.value;
						}

						if (selectedGrpData?.code == Consts.VEHICLES) {
							tempData = generateData('vehicles', tempData)
							// tempData = tempData.filter(e => e?.vehicles && e?.vehicles.length > 0).map((item) => item?.vehicles[0])
						} else if (selectedGrpData?.code == Consts.TRAILERS || selectedGrpData?.code == Consts.CHASSIS) {
							tempData = generateData('trailers', tempData)
							// tempData = tempData.filter(e => e?.trailers && e?.trailers.length > 0).map((item) => item?.trailers[0])
						} else if (selectedGrpData?.code == Consts.DRIVERS) {
							tempData = generateData('drivers', tempData)
							// tempData = tempData.filter(e => e?.drivers && e?.drivers.length > 0).map((item) => item?.drivers[0])
						} else if (selectedGrpData?.code == Consts.VARIOUS) {
							tempData = generateData('variousResources', tempData)
							// tempData = tempData.filter(e => e?.variousResources && e?.variousResources.length > 0).map((item) => item?.variousResources[0])
						}
						setTotalData(tempData.length);

						tempData = service.setColorCodeAndDate(tempData, resourceGridColumnList);
						setIsApiLoaded(true);
						if (response['@odata.nextLink'] !== null && response['@odata.nextLink'] !== undefined) {
							setNextDataUrl(response['@odata.nextLink']);
						}
						setmyGridData(tempData);
						setLoadedGridData(tempData);
						setTempResourceData(tempData);
					}
				}
			}).catch(error => {
				console.error('API error:', error);
			}).finally(() => {
				setIsLoading(false);
			});
		} else {
			setIsLoading(false);
		}
	}

	const generateData = (key, data) => {
		const _tData = data.filter(e => e?.[key] && e?.[key].length > 0)
		const _rData = []
		_tData.forEach(element => {
			const _obj1 = {resourceId: element.resourceId, resourceNo: element.resourceNo, resourceType: element.resourceType};
			const _obj2 = element[key][0];
			_rData.push(_.merge(_obj1, _obj2))
		});
		return _rData;
		//.map((item) => item?.[key][0])
	};

	const updateSendApi = useMemo(() => {
		return _.debounce((size) => {
			sendApi(null, size);
		}, 250);
	}, [sendApi]);
	// --- API's Call END ---
	const getResourceData = () => {
		setIsLoading(true)
		apiService.get(planGroups, null).then((response) => {
			setMyResources(response?.value);
			let resourceTypes = [...new Set(response.value.map(item => item.resourceType))].map(resourceType => ({ code: resourceType }));
			setResourceTypeData(resourceTypes)
			let planGroupData = response?.value.filter((item) => item.resourceType === resourceTypes[0].code)
			setSelectedRecData(resourceTypes[0])
			setSelectedGrpData(planGroupData[0])
			setResFilterComponents(prevComponents =>
				prevComponents.map(component => {
					if (component.key === 'resourceType') {
						return { ...component, data: resourceTypes, value: resourceTypes[0] };
					} else if (component.key === 'planGroup') {
						return { ...component, data: planGroupData, value: planGroupData[0] };
					}
					return component;
				})
			);
			setIsApiCallRequired(true);
		})
	}
	useEffect(() => {
		setIsApiLoaded(true);
		getResourceData()
		setGridColumns(entity);
		let tempFilterData = [];
		if (days > 0) {
			// tempFilterData.push({ field: 'startingDate', value: service.dateFormat(startDate, 'startDate') + (days > 0 ? ".." + service.dateFormat(startDate, 'startDate', days) : ""), isLast: false, type: 'Edm.Date' });
		} else {
			// tempFilterData.push({ field: 'startingDate', value: ">=" + service.dateFormat(startDate, 'startDate'), isLast: false, type: 'Edm.Date' });
		}
		tempFilterData.push({ field: 'resourceType', value: `=${selectedGrpData?.code}`, isLast: false, type: 'Edm.String' });
		tempFilterData.push({ field: 'planGroup', value: `=${selectedGrpData?.code}`, isLast: false, type: 'Edm.String' });

		setInitialFilter(tempFilterData);
	}, []);
	useEffect((e) => {
		if (!_.isNil(paramsData) && isApiCallRequired) {
			updateSendApi(loadSelectionValue);
		} else {
			setIsApiCallRequired(true);
		}
	}, [paramsData]);
	useEffect((e) => {
		if (!_.isNil(tempResourceGridColumnList)) {
			setNextDataUrl(null);
			updateSendApi(loadSelectionValue);
		}
	}, [tempResourceGridColumnList]);

	return (
		<>
			{isLoading ? (<Spinner2 isAll={loadSelectionValue} />) : (<></>)}
			<Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }} id={odataApiName}>
				<AlertComponent isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose} />
				{isResource && <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
					<Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Resource</Typography>
				</Box>}
				<Grid container sx={{ marginTop: 0 }}  >
					<Grid item={true} xs component={Card} elevation={0} pl={0} sx={{ flexGrow: 1 }} className='grid-movement'>
						{isApiLoaded && <DataGridComponent
							{...props}
							hideSavedView={true}
							gridRef={subContractorGrid}
							gridFlagVal={odataApiName}
							gridFlagValFor={odataApiNameFor}
							gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px' }}
							gridNewData={myGridData}
							loadedGridData={loadedGridData}
							tempGridData={resourceData}
							gridColumnList={resourceGridColumnList ? resourceGridColumnList : []}
							gridTempColumnList={tempResourceGridColumnList ? tempResourceGridColumnList : []}
							isItemVisible={true}
							gridSort={initialSort}
							gridInitialFilter={initialFilter}
							isShowGridHeader={isResource}
							griddDtaItemKey={transportAddressDataItemKey}
							gridDraggable={true}
							sendDataToParent={childStateHandler}
							gridDataAction={dataRelatedAction}
							gridFilterComponents={resFilterComponents}
							onLoadSelectionChange={onLoadSelectionChange}
							loadSelectionValue={loadSelectionValue}
							gridtotalData={totalData}
							// initialSaveViewData={initialSaveViewData}
							initialFetchReadLinkData={initialFetchReadLinkData}
							selectableMode={"single"}
							changeToChild={changeToChildResource}
							isDraggable={true}
						/>}
					</Grid>
				</Grid>
			</Grid>
		</>
	)
};

export default Resources;